$( document ).ready( () => {
	$( '.js-slider-images-content' ).each( function() {

		var navigationNext     = $( this ).parents( '.slider-images-content-wrap' ).find('.swiper-button-next')[0];
		var navigationPrev     = $( this ).parents( '.slider-images-content-wrap' ).find('.swiper-button-prev')[0];

		new Swiper( this, {
			loop:          true,
			autoHeight:    true,
			slidesPerView: 1,
			spaceBetween:  0,

			pagination: {
				el: $( this ).find( '.swiper-pagination' )[0],
				clickable: true,
			},
			navigation: {
				nextEl: navigationNext,
				prevEl: navigationPrev,
			},
		} );
	} );
} );